import { Routes } from '@angular/router';
import { ErrorComponent } from './shared/error/error.component';
import { HomeComponent } from './pages/home/home.component';
import { LogoutCallbackComponent } from './shared/logout/logout-callback.component';
import { SuccessComponent } from './pages/success/success.component';

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  { path: 'success', component: SuccessComponent },
/*   {
    path: 'contact',
    loadComponent: () => import('./pages/contact/contact.component').then(m => m.ContactComponent),
  },
  {
    path: 'links',
    loadComponent: () => import('./pages/links/links.component').then(m => m.LinksComponent),
  }, */
  {
    path: 'impressum',
    loadComponent: () => import('./pages/impressum/impressum.component').then(m => m.ImpressumComponent),
  },
  {
    path: 'terms',
    loadComponent: () => import('./pages/terms/terms.component').then(m => m.TermsComponent),
  },
  {
    path: 'user-info',
    loadComponent: () => import('./pages/user-info/user-info.component').then(m => m.UserInfoComponent),
  },
  {
    path: 'reservations',
    loadComponent: () => import('./pages/reservations/reservations.component').then(m => m.ReservationsComponent),
  },
  {
    path: 'rent-duration',
    loadComponent: () => import('./pages/rent/rent-duration/rent-duration.component').then(m => m.RentDurationComponent),
  },
  {
    path: 'rent-location',
    loadComponent: () => import('./pages/rent/rent-location/rent-location.component').then(m => m.RentLocationComponent),
  },
  {
    path: 'rent-persons',
    loadComponent: () => import('./pages/rent/rent-persons/rent-persons.component').then(m => m.RentPersonsComponent),
  },
  {
    path: 'rent-products',
    loadComponent: () => import('./pages/rent/rent-products/rent-products.component').then(m => m.RentProductsComponent),
  },
  {
    path: 'rent-shopping-basket',
    loadComponent: () => import('./pages/rent/rent-shopping-basket/rent-shopping-basket.component').then(m => m.RentShoppingBasketComponent),
  },
  {
    path: 'widget-generator',
    loadComponent: () => import('./pages/widget/widget-generator/widget-generator.component').then(m => m.WidgetGeneratorComponent),
  },
  {
    path: 'widget',
    loadComponent: () => import('./pages/widget/widget/widget.component').then(m => m.WidgetComponent),
    data: { hideRibbon: true },
  },
  {
    path: 'payment-complete',
    loadComponent: () => import('./pages/payment/payment-complete.component').then((m) => m.PaymentCompleteComponent),
  },

  { path: 'logout-callback', component: LogoutCallbackComponent },
  { path: 'error', component: ErrorComponent },
  { path: '**', redirectTo: 'home' },
];
